import { Injectable } from '@angular/core';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { BsDatepickerContainerComponent } from 'ngx-bootstrap/datepicker/themes/bs/bs-datepicker-container.component';


function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

function isNumber(value: any): boolean {
  return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}

@Injectable({
  providedIn: 'root'
})
export class DatepickerHelperService {

  setInitialTime(dateFrom: Date): void {
    if (dateFrom) {
      dateFrom.setUTCHours(0, 0, 0, 0);
    }
  }

  setEndTime(dateTo: Date): void {
    if (dateTo) {
      dateTo.setUTCHours(23, 59, 59, 999);
    }
  }

  format(date: Date): string {
    if (date && !(date instanceof Date)) {
      date = new Date(date);
    }
    let stringDate = '';
    if (date) {
      stringDate += isNumber(date.getUTCDate()) ? padNumber(date.getUTCDate()) + '/' : '';
      stringDate += isNumber(date.getUTCMonth()) ? padNumber(date.getUTCMonth() + 1) + '/' : '';
      stringDate += date.getUTCFullYear();
    }
    return stringDate;
  }

  secondFormat(date: Date): string {
    if (date && !(date instanceof Date)) {
      date = new Date(date);
    }
    let stringDate = '';
    if (date) {
      stringDate += date.getUTCFullYear() + '-';
      stringDate += isNumber(date.getUTCMonth()) ? padNumber(date.getUTCMonth() + 1) + '-' : '';
      stringDate += isNumber(date.getUTCDate()) ? padNumber(date.getUTCDate()) : '';
    }
    return stringDate;
  }

  onShow(datepickers: BsDatepickerDirective[]): void {
    const today = new Date();

    datepickers.forEach(datepicker => {
      if (datepicker) {
        datepicker.onShown.subscribe((v: BsDatepickerContainerComponent) => {
          v.daysCalendar$.subscribe(s => {
            if (s && s.length) {
              if (s[0] && s[0].month.getFullYear() === today.getFullYear()) {
                if (s[0].month.getMonth() === today.getMonth()) {
                  s[0].weeks.forEach(week => {
                    if (week && week['days']) {
                      week['days'].forEach(day => {
                        if (day && !day.isOtherMonth && day.label === today.getDate().toString()) {
                          day.isHovered = true;
                        }
                      });
                    }
                  });
                }
              }
            }
          });
        });
      }
    });
  }
}
